import React, { useCallback } from 'react';
import TranslateManager from 'ts-translate-js';
import { AddToCartPackageRequest, AddToCartRequest, AddToCartRequestBase } from '../../../mvcapi/models/buyticket/ticketselection';

const tr = TranslateManager.boundTR;

interface PromoDesactivationControlProps {
    hiddenPromo: boolean;
    onPromoDeactivated: () => void;
    addToCartRequest: AddToCartRequestBase;
    onPriceChangeSuggestions: (priceChangeSuggestions: any[]) => void;
    isAPackageSale: boolean;
}
export function PromoDesactivationControl({hiddenPromo, onPromoDeactivated, addToCartRequest, onPriceChangeSuggestions, isAPackageSale}: PromoDesactivationControlProps){   
    const handleDeactivateClick = useCallback(async (e) => {
        e.stopPropagation();
        e.preventDefault();
        let passwordRequest;
        
        if(isAPackageSale){
            passwordRequest = await tsapp.mvcapi.postCtl("buypackage/clearactivepromocode", {
                addToCartRequest: addToCartRequest as AddToCartPackageRequest
            });
        } else {
            passwordRequest = await tsapp.mvcapi.postCtl("buyticket/clearactivepromocode", {
                addToCartRequest: addToCartRequest as AddToCartRequest
            });
        }

        onPromoDeactivated();

        if(passwordRequest.priceChangeSuggestions && onPriceChangeSuggestions)
            onPriceChangeSuggestions(passwordRequest.priceChangeSuggestions);
        
    }, [isAPackageSale, onPromoDeactivated, onPriceChangeSuggestions, addToCartRequest]);

    return <div className="alert alert-warning">
        {tr("Vous avez une promotion présentement active.")}
        {/* TODO: Refactor this as a button */}
        {/* eslint-disable-next-line sonarjs/anchor-is-valid */}
        &nbsp;{!hiddenPromo && <a href="#" className="" onClick={handleDeactivateClick}>
        {tr("Cliquez ici si vous désirez la désactiver.")}
        </a>}
    </div>;
}